import {AutoComplete, Button, Input, Modal, Spin, Tag, Typography, Upload} from "antd";
import React, {useEffect, useRef, useState} from "react";
import Dragable, {DraggableData, DraggableEvent} from "react-draggable";
import './ModalStyles.scss';
import {ObjectModel} from "../../models/ObjectModel";
import {objectAPI} from "../../services/ObjectService";
import {MessageModel} from "../../models/MessageModel";
import {MessageCard} from "./MessageCard";
import {messageAPI} from "../../services/MessageService";
import {NoMessageCard} from "./NoMessageCard";
import {TaskGridModel} from "../../models/TaskGridModel";
import {ObjectGridModel} from "../../models/ObjectGridModel";
import {EquipmentModel} from "../../models/EquipmentModel";
import {host, port, secure} from "../../config/config";
import {taskAPI} from "../../services/TaskService";

const {Text} = Typography;

type ModalProps = {
    infoNotification: Function,
    errorNotification: Function,
    setVisible: Function,
    getTasks: Function,
    selectedTask: TaskGridModel,
}

export const TaskModal = (props: ModalProps) => {
    // Draggable settings
    const [disabled, setDisabled] = useState<boolean>(false);
    const [bounds, setBounds] = useState({left: 0, top: 0, bottom: 0, right: 0});
    const draggableRef = useRef<HTMLDivElement>(null);
    const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
        const {clientWidth, clientHeight} = window.document.documentElement;
        const targetRect = draggableRef.current?.getBoundingClientRect();
        if (!targetRect) {
            return;
        }
        setBounds({
            left: -targetRect.left + uiData.x,
            right: clientWidth - (targetRect.right - uiData.x),
            top: -targetRect.top - uiData.y,
            bottom: clientHeight - (targetRect.bottom - uiData.y),
        })
    }
    // End of dnd
    const [getObjectsRequest, {
        data: dataGetObjectsRequest,
        isLoading: isGettingObjectsInProcess,
    }] = objectAPI.useGetObjectsMutation();
    const [getMessagesRequest, {
        data: dataGetMessagesRequest,
        isLoading: isLoadingGetMessages,
        isError: isErrorCGetMessagesRequest,
    }] = messageAPI.useGetTaskMessagesMutation();
    const [getTaskByIdRequest, {
        data: dataGetTaskByIdRequest,
        isLoading: isLoadingGetTaskById,
        isError: isErrorGetTaskById,
    }] = taskAPI.useGetTaskByIdMutation();
    const [messages, setMessages] = useState<MessageModel[]>();
    const [selectedObject, setSelectedObject] = useState<string>(() => props.selectedTask.object ?? '');
    const [equipments, setEquipments] = useState<{ value: string }[]>([]);
    const [selectedEquipment, setSelectedEquipment] = useState<string>(props.selectedTask.equipment ?? '');
    const [client, setClient] = useState<string>(props.selectedTask.creator);
    const [title, setTitle] = useState<string>(props.selectedTask.title);
    const [description, setDescription] = useState<string>(props.selectedTask.description);
    const [date, setDate] = useState<string>(props.selectedTask.date);
    const [status, setStatus] = useState<string>(props.selectedTask.status);
    const [isLoadingUpdateTask, setIsLoadingUpdateTask] = useState<boolean>(false);
    const [modalWidth,] = useState<number>(1200);
    useEffect(() => {
        if (props.selectedTask.id) getMessagesRequest(props.selectedTask.id.toString())
        if (props.selectedTask.id) getTaskByIdRequest(props.selectedTask.id.toString())
        getObjectsRequest()
    }, []);
    useEffect(() => {
        if (dataGetMessagesRequest) setMessages(dataGetMessagesRequest)
    }, [dataGetMessagesRequest]);
    useEffect(() => {
        if (selectedObject && dataGetObjectsRequest) {
            let object: ObjectGridModel | undefined = dataGetObjectsRequest.find((object: ObjectModel) => object.name === selectedObject)
            if (object) {
                setEquipments(object.equipments.map((equipment: EquipmentModel) => ({value: equipment.name + '#' + equipment.code})))
            } else {
                setEquipments([])
                setSelectedEquipment('')
            }
        }
    }, [selectedObject]);
    useEffect(() => {
        if (dataGetObjectsRequest) {
            let object: ObjectGridModel | undefined = dataGetObjectsRequest.find((object: ObjectModel) => object.name === selectedObject)
            if (object) {
                setEquipments(object.equipments.map((equipment: EquipmentModel) => ({value: equipment.name + '#' + equipment.code})))
            } else {
                setEquipments([])
                setSelectedEquipment('')
            }
        }
    }, [dataGetObjectsRequest])
    const updateTaskHandler = () => {
        if (!equipments.find((equipment: { value: string }) => equipment.value === selectedEquipment)) {

        } else if (selectedObject && selectedEquipment && title) {
            let myHeaders = new Headers();
            myHeaders.append("authorization", `Bearer ${localStorage.getItem('token')}`);

            let formData = new FormData();
            if (dataGetTaskByIdRequest)
                if (dataGetTaskByIdRequest.id)
                    formData.append("id", dataGetTaskByIdRequest.id.toString());
            formData.append("object", selectedObject);
            formData.append("equipment", selectedEquipment);
            formData.append("title", title);
            formData.append("description", description ?? "");
            let oldPhotosIds: string[] = []
            let photos = dataGetTaskByIdRequest?.photos.map((photoId: string) => (
                {
                    uid: photoId,
                    name: `photo${photoId}.png`,
                    status: 'success',
                    url: `${secure}://${host}${port}/tasks/getPhotoById/${photoId}`,
                    percent: 100,
                }
            ));
            photos?.map((photo: any) => oldPhotosIds.push(photo.uid))
            formData.append("oldPhotosIds", oldPhotosIds.toString());
            let requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: formData,
                redirect: 'follow'
            };
            setIsLoadingUpdateTask(true);
            //@ts-ignore
            fetch(`${secure}://${host}${port}/tasks/update`, requestOptions)
                .then(response => response.text())
                .then(result => {
                    let response = JSON.parse(result);
                    if (response.status === 200) {
                        props.getTasks();
                        props.infoNotification("Заявка обновлена");
                        props.setVisible(false);
                        setIsLoadingUpdateTask(false);
                    }
                })
                .catch(error => {
                    setIsLoadingUpdateTask(false);
                });
        } else {
        }
    };
    // @ts-ignore
    return (
        <Modal
            title={`Заявка №${props.selectedTask.id}`}
            centered={true}
            open={true}
            footer={[]}
            modalRender={(modal) => (
                // @ts-ignore
                <Dragable
                    disabled={disabled}
                    bounds={bounds}
                    onStart={(event, uiData) => onStart(event, uiData)}
                >
                    <div ref={draggableRef}>{modal}</div>
                </Dragable>
            )}
            width={modalWidth}
            onCancel={() => props.setVisible(false)}
        >
            <div className="twoWindowFlexTask">
                <div className="modalFlexTask">
                    <div onMouseOver={() => setDisabled(true)} className="modalInputTask">
                        <Text style={{fontFamily: 'Roboto'}}>Объект</Text>
                        <AutoComplete
                            disabled={isGettingObjectsInProcess}
                            value={selectedObject}
                            options={dataGetObjectsRequest ? dataGetObjectsRequest.map((item: ObjectModel) => ({
                                value: item.name,
                            })) : []}
                            style={{width: '100%'}}
                            onChange={setSelectedObject}
                            filterOption={(inputValue, option) => {
                                let opt = option!.value as unknown as string
                                return opt?.toUpperCase()?.indexOf(inputValue?.toUpperCase()) !== -1
                            }
                            }
                            notFoundContent={'Объект не найден'}
                        />
                    </div>
                    <div onMouseOver={() => setDisabled(true)} className="modalInputTask">
                        <Text style={{fontFamily: 'Roboto'}}>Наименование техники/инвентарник</Text>
                        <AutoComplete
                            disabled={isGettingObjectsInProcess}
                            value={selectedEquipment}
                            onChange={setSelectedEquipment}
                            options={equipments}
                            style={{width: '100%'}}
                            onSelect={setSelectedEquipment}
                            filterOption={(inputValue, option) => {
                                let opt = option!.value as unknown as string
                                return opt?.toUpperCase()?.indexOf(inputValue?.toUpperCase()) !== -1
                            }
                            }
                            notFoundContent={'Оборудование не найдено'}
                        />
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                         className="modalInputTask">
                        <Text style={{marginBottom: 5}}>Заказчик</Text>
                        <Text>{client}</Text>
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                         className="modalInputTask">
                        <Text style={{marginBottom: 5}}>Заявленная неисправность</Text>
                        <Input value={title} onChange={(e: any) => setTitle(e.target.value)}/>
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                         className="modalInputTask">
                        <Text style={{marginBottom: 5}}>Описание неисправности</Text>
                        <Input value={description} onChange={(e: any) => setDescription(e.target.value)}/>
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                         className="modalInputTask">
                        <Text style={{marginBottom: 5}}>Дата создания</Text>
                        <Text>{date}</Text>
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                         className="modalInputTask">
                        <Text style={{marginBottom: 5}}>Статус</Text>
                        {status === "created" && <Text><Tag color={"green"}>Создано</Tag></Text>}
                        {status === "inProcess" && <Text><Tag color={"processing"}>В работе</Tag></Text>}
                        {status === "completed" && <Text><Tag color={"magenta"}>Выполнено</Tag></Text>}
                    </div>
                    <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                         className="modalInputTask">
                        <Text style={{marginBottom: 5}}>Приложенные файлы</Text>
                        {isLoadingGetTaskById ?
                            <div style={{
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontFamily: 'Roboto',
                                fontSize: 14,
                            }}>
                                <Spin size={'large'} style={{marginRight: 15}}/>
                                Загрузка файлов...
                            </div> :
                            <Upload
                                // @ts-ignore
                                defaultFileList={dataGetTaskByIdRequest?.photos.map((photoId: string) => (
                                    {
                                        uid: photoId,
                                        name: `photo${photoId}.png`,
                                        status: 'success',
                                        url: `${secure}://${host}${port}/tasks/getPhotoById/${photoId}`,
                                        percent: 100,
                                    }
                                ))}
                                style={{width: '95vw'}}
                                multiple accept={'image/png, image/jpeg'}
                                maxCount={3}
                                listType="picture">
                            </Upload>
                        }
                        <Upload
                            defaultFileList={[
                                {
                                    uid: "1231",
                                    name: `Заявка.xlsx`,
                                    // @ts-ignore
                                    status: 'success',
                                    url: `${secure}://${host}${port}/tasks/getDocumentByTaskId/${props.selectedTask.id}`,
                                    percent: 100,
                                }
                            ]}
                            style={{width: '95vw'}}
                            multiple accept={'text/xml'}
                            maxCount={3}>
                        </Upload>
                    </div>
                </div>
                <div className="modalFlexTask" style={{width: 600, height: 553, overflow: 'scroll'}}>
                    {isLoadingGetMessages &&
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontFamily: 'Roboto',
                            fontSize: 14,
                            marginTop: '250px',
                        }}>
                            <Spin size={'large'} style={{marginRight: 15}}/>
                            Загрузка диалога...
                        </div>}
                    {messages?.length === 0 ?
                        <div style={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <NoMessageCard/>
                        </div>
                        :
                        messages?.map((message: MessageModel) => {
                            if (message.date && message.userFrom !== undefined && message.userRole !== undefined)
                                return (
                                    <MessageCard date={message.date} message={message.message} sender={message.userFrom}
                                                 role={message.userRole}/>
                                )
                        })
                    }
                </div>
            </div>
            <div onMouseOver={() => setDisabled(true)} onMouseLeave={() => setDisabled(false)}
                 className="modalButtonsTask">
                <Button disabled={isLoadingUpdateTask || isGettingObjectsInProcess} onClick={updateTaskHandler}>Сохранить</Button>
                <Button style={{marginLeft: 25}} onClick={() => props.setVisible(false)}>Отменить</Button>
            </div>
        </Modal>
    )
}